import { Injectable } from '@angular/core';
import { AppSettings, PaymentType } from '../../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { currentcartdetail } from '../../../models/dashboard/cart/mywallet.currentcart.Modal';
import { SendMoneyDetail, PickupType } from '../../../models/sendmoney/sendmoney';
import { UserGioLocation } from '../../../models/user/usergioLocation';
import { geolocation } from '../../../sharedcomponents/commonservice/geolocation/geoloc';
@Injectable()
export class CartServiceService {
  private subcurrentcartdetail = new ReplaySubject<currentcartdetail>();
  userGioLocation: UserGioLocation;
  constructor(private utilserv: utilityService, private geoloc: geolocation) { }
  getcartlistservice() {
    return this.utilserv.soapPostwithoutAction(this.getcartlistenvolpe(), AppSettings.OrderProcessingService);
  }
  getcartlistenvolpe() {
    let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                          <s:Header>
                            <a:Action s:mustUnderstand="1">http://tempuri.org/IOrderProcessingService/GetCartItems</a:Action>
                            <a:MessageID>urn:uuid:b2144f4a-8364-4cba-88b8-39114221e947</a:MessageID>
                            <a:ReplyTo>
                              <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                            </a:ReplyTo>
                          </s:Header>
                          <s:Body>
                            <GetCartItemRequest xmlns="http://tempuri.org/">
                            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                              <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                              </Session>
                            </GetCartItemRequest>
                          </s:Body>
                        </s:Envelope>`;
    return envelope;
  }
  deletecartitem(itemID: string) {
    return this.utilserv.restPost(this.deletecartitemenvolpe(itemID), AppSettings.CartActionItemServices + '/rest/DeleteItemFromCart');
  }
  deletecartitemenvolpe(itemID: string) {
    const envelope = `{
                        "CustomerId":"1",
                        "ItemId":"${itemID}",
                        "LanguageCode":"${sessionStorage.langCode}",
                        "Session":{
                                    "T1":"${sessionStorage.T1}",
                                    "T2":"${sessionStorage.T2}"
                                  }
                        }`;

    return envelope;
  }
  deletetransitem(itemID: string) {
    const serviceUrl = AppSettings.CartActionItemServices + '/rest/DeleteFundingFailedItem';
    return this.utilserv.restPost(this.deletetransitemnvolpe(itemID), serviceUrl);
  }

  deletetransitemnvolpe(itemID: string) {
    const envelope = `{
                        "ItemId":"${itemID}",
                        "LanguageCode":"${sessionStorage.langCode}",
                        "Session":{
                                    "T1":"${sessionStorage.T1}",
                                    "T2":"${sessionStorage.T2}"
                                  }
                        }`;

    return envelope;
  }

  getcarttypeservice() {
    return this.utilserv.restPost(this.getcarttypeenvolpe(), AppSettings.CartActionItemServices + '/rest/GetCurrentCartInfo');
  }

  getcarttypeenvolpe() {
    // const envelope = `{
    //                   "LanguageCode":"${sessionStorage.langCode}",
    //                   "Session":{
    //                               "T1": "",
    //                               "T2":"${sessionStorage.T2}"
    //                             },
    //                       "isAsync":true
    //                   }`;
    const envelope = `{"IsAsync":true,"LanguageCode":"${sessionStorage.langCode}","Session":{"T2":"${sessionStorage.T2}"}}`;
    return envelope;
  }

  setcurrentcartDetailDashBoardData(dataValues: currentcartdetail) {
    this.subcurrentcartdetail.next(dataValues);
  }

  getcurrentcartDetailDashBoardData(): Observable<any> {
    return this.subcurrentcartdetail.asObservable();
  }

  addCartItem(reqObject: SendMoneyDetail, userGioLocation: any) {
    return this.utilserv.soapPostwithoutAction(this.addCartItemEnvelope(reqObject, userGioLocation), AppSettings.OrderProcessingService);
  }
  addCartItemEnvelope(reqObject: SendMoneyDetail, userGioLocation: any) {

    //console.log("el token de car es ", sessionStorage.T1)
    // let userGioLocation = new UserGioLocation();
    // this.geoloc.getserGioLocation().subscribe(data => {
    //   userGioLocation = data;
    // });
    //console.log("informacion del carrito", reqObject)
    reqObject.paymentDetails.totalAmount = this.utilserv.roundOff(this.utilserv.roundOff(reqObject.paymentDetails.srcAmount) + this.utilserv.roundOff(reqObject.paymentDetails.processingFee))
    let envelope =
      '<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">\n' +
      '<s:Header>\n' +
      '<a:Action s:mustUnderstand="1">http://tempuri.org/IOrderProcessingService/AddToShoppingCart</a:Action>\n' +
      '<a:MessageID>urn:uuid:1c02142d-2953-490b-a8e1-91080eae693f</a:MessageID>\n' +
      '<a:ReplyTo>\n' +
      '<a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>\n' +
      '</a:ReplyTo>\n' +
      '</s:Header>\n' +
      '<s:Body>\n' +
      '<AddToCartRequest xmlns="http://tempuri.org/">\n' +
      '<AmountLocal>' +
      reqObject.paymentDetails.srcAmount.toFixed(4)  +
      '</AmountLocal>\n';
    if (reqObject.pickupTypeDetails.pickupType == PickupType.bankDeposit) {
      envelope +=
        '<BankAccountNumber>' +
        reqObject.bankAccountDetails.BankAccountNumber +
        '</BankAccountNumber>\n' +
        '   <BankAccountType>' +
        reqObject.bankAccountDetails.BankAccountType +
        '</BankAccountType>\n' +
        '   <BankCity>' +
        reqObject.bankAccountDetails.BankCity +
        '</BankCity>\n' +
        '   <BankCode>' +
        reqObject.bankAccountDetails.routingNumber +
        '</BankCode>\n' +
        '   <BankName>' +
        reqObject.bankAccountDetails.BankName +
        '</BankName>\n';
    }
    envelope +=
      '<BeneficiaryChecksum>0</BeneficiaryChecksum>\n' +
      '   <BeneficiaryId>' +
      reqObject.beneficiaryDetails.BeneficiaryId +
      '</BeneficiaryId>\n' +
      '   <Commission>' +
      this.utilserv.roundOff(reqObject.paymentDetails.processingFee) +
      '</Commission>\n' +
      '   <CountryCodeFrom>' +
      reqObject.agentDetails.CountryFrom +
      '</CountryCodeFrom>\n' +
      '   <CountryCodeTo>' +
      reqObject.agentDetails.CountryTo +
      '</CountryCodeTo>\n' +
      '   <CurrencyCodeFrom>' +
      reqObject.paymentDetails.srcCurrCode +
      '</CurrencyCodeFrom>\n' +
      '   <CurrencyCodeTo>' +
      reqObject.paymentDetails.destCurrCode +
      '</CurrencyCodeTo>\n' +
      '   <CustomerChecksum>0</CustomerChecksum>\n' +
      '   <CustomerId>' +
      reqObject.userDetails.UserID +
      '</CustomerId>\n' +
      '   <CustomerPaymentMethod>' +
      reqObject.paymentDetails.paymentType +
      '</CustomerPaymentMethod>\n' +
      '   <DeliveryMethod>' +
      reqObject.pickupTypeDetails.pickupType +
      '</DeliveryMethod>\n' +
      '   <EndUserIP>' +
      sessionStorage.EndUserIP +
      '</EndUserIP>\n' +
      '   <EndUserLatitude>' +
      userGioLocation.latitude +
      '</EndUserLatitude>\n' +
      '   <EndUserLongitude>' +
      userGioLocation.longitude +
      '</EndUserLongitude>\n' +
      `   <EntryType>${AppSettings.Platform}</EntryType>\n` +
      '   <FundSource>' +
      reqObject.additionalInfo.fundSource +
      '</FundSource>\n' +
      `<FundingId>${reqObject.paymentDetails.paymentType == 30 ? reqObject.paymentDetails.fundingId : 0}</FundingId> \n` +
      '   <LanguageCode>' +
      sessionStorage.langCode +
      '</LanguageCode>\n' +
      '<MarketingBalance>' +
      reqObject.userDetails.MarketingBalance +
      '</MarketingBalance>\n' +
      '   <PayingAgentId>' +
      reqObject.branchDetails.PayingAgentId +
      '</PayingAgentId>\n' +
      '   <PayingAgentLocationId>' +
      reqObject.branchDetails.LocationId +
      '</PayingAgentLocationId>\n' +
      '   <ProgramId>' +
      reqObject.sendMoneyProgramDetail.ProgramId +
      '</ProgramId>\n' +
      '   <Rate>' +
      reqObject.paymentDetails.exchangeRate +
      '</Rate>\n' +
      '   <ReceivingAgentId>0</ReceivingAgentId>\n' +
      '   <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">\n\n' +
      '       <d4p1:T1>' +
      sessionStorage.T1 +
      '</d4p1:T1>\n' +
      '       <d4p1:T2>' +
      sessionStorage.T2 +
      '</d4p1:T2>\n' +
      '   </Session>\n';

    if (reqObject.paymentDetails.paymentType == PaymentType.PayAtStore) {
      envelope +=
        '    <Store xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">\n' +
        '    <d4p1:LanguageCode i:nil="true" />\n' +
        '   <d4p1:Session i:nil="true" />\n' +
        '    <d4p1:Address>\n' +
        '     <d4p1:Address1>' +
        reqObject.storeDetails.storeaddress.Address1 +
        '</d4p1:Address1>\n' +
        '     <d4p1:CityCode>' +
        reqObject.storeDetails.storeaddress.CityCode +
        '</d4p1:CityCode>\n' +
        '     <d4p1:CountryCode>' +
        reqObject.storeDetails.storeaddress.CountryCode +
        '</d4p1:CountryCode>\n' +
        '     <d4p1:Latitude>' +
        reqObject.storeDetails.storeaddress.Latitude +
        '</d4p1:Latitude>\n' +
        '     <d4p1:Longitude>' +
        reqObject.storeDetails.storeaddress.Longitude +
        '</d4p1:Longitude>\n' +
        '     <d4p1:StateCode>' +
        reqObject.storeDetails.storeaddress.StateCode +
        '</d4p1:StateCode>\n' +
        '      <d4p1:ZipCode>' +
        reqObject.storeDetails.storeaddress.ZipCode +
        '</d4p1:ZipCode>\n' +
        '    </d4p1:Address>\n' +
        '    <d4p1:ClosingTime>' +
        reqObject.storeDetails.storeClosingTime +
        '</d4p1:ClosingTime>\n' +
        '    <d4p1:Directions>' +
        reqObject.storeDetails.storedirections +
        '</d4p1:Directions>\n' +
        '    <d4p1:Distance>' +
        reqObject.storeDetails.storedistance +
        '</d4p1:Distance>\n' +
        '    <d4p1:Email>' +
        reqObject.storeDetails.storemail +
        '</d4p1:Email>\n' +
        '    <d4p1:Limitations><![CDATA[' +
        reqObject.storeDetails.storeLimitations +
        ']]></d4p1:Limitations>\n' +
        '    <d4p1:Name><![CDATA[' +
        reqObject.storeDetails.storeName +
        ']]></d4p1:Name>\n' +
        '    <d4p1:Notes><![CDATA[' +
        reqObject.storeDetails.storenotesSection +
        ']]></d4p1:Notes>\n' +
        '    <d4p1:OpeningTime>' +
        reqObject.storeDetails.storeOpeningTime +
        '</d4p1:OpeningTime>\n' +
        '    <d4p1:PhoneNumber>' +
        reqObject.storeDetails.storePhoneNumber +
        '</d4p1:PhoneNumber>\n' +
        '    <d4p1:Restrictions><![CDATA[' +
        reqObject.storeDetails.storeRestrictions +
        ']]></d4p1:Restrictions>\n' +
        '    <d4p1:SpecialInstructions><![CDATA[' +
        reqObject.storeDetails.storespecialInstructionSection +
        ']]></d4p1:SpecialInstructions>\n' +
        '    <d4p1:StoreID>' +
        reqObject.storeDetails.storeId +
        '</d4p1:StoreID>\n' +
        '    <d4p1:TimeForThisWeek>' +
        reqObject.storeDetails.storeScheduleThisWeekThisWeek +
        '</d4p1:TimeForThisWeek>\n' +
        '   </Store>\n';
    }
    if (reqObject.branchDetails.TaxAmount != 0 && reqObject.branchDetails.TaxAmount != null) {
      envelope += 
      '<TaxAmount>' +
      reqObject.branchDetails.TaxAmount +
      '</TaxAmount>\n' +
      '<TaxDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.CoreApi.Models" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">' +
      '<d4p1:Amount>' +
      reqObject.branchDetails.TaxDetails[0].Amount +
      '</d4p1:Amount> \n' +
      '<d4p1:Description>' +
      reqObject.branchDetails.TaxDetails[0].Description +
      '</d4p1:Description> \n' +
      '<d4p1:Name>' +
      reqObject.branchDetails.TaxDetails[0].Name +
      '</d4p1:Name> \n' +
      '</TaxDetails>\n';
    }
    envelope +=
      '<TotalAmount>' +
      // parseFloat(reqObject.paymentDetails.totalAmount.toString()) +
      //.toFixed(reqObject.roundingPlaces) after exchange rate in line 289
      (reqObject.paymentDetails.totalAmount > reqObject.userDetails.MarketingBalance ? reqObject.paymentDetails.totalAmount - reqObject.userDetails.MarketingBalance + (reqObject.branchDetails.TaxAmount != null && reqObject.branchDetails.TaxAmount != 0? reqObject.branchDetails.TaxAmount : 0) : 0).toFixed(
        reqObject.roundingPlaces
      ) +
      '</TotalAmount>\n' +
      '<TransferAmount>' +
      reqObject.paymentDetails.destAmount
      +
      // (this.utilserv.roundOff(reqObject.paymentDetails.srcAmount) * Number(reqObject.paymentDetails.exchangeRate)).toFixed(reqObject.roundingPlaces) +
      '</TransferAmount>\n' +
      '<TransferReason>' +
      reqObject.additionalInfo.reasonSendingMoney +
      '</TransferReason>\n' +
      '</AddToCartRequest>\n' +
      '</s:Body>\n' +
      '</s:Envelope>\n';
    return envelope;
  }

  payShopingCart(reqObject: SendMoneyDetail) {
    return this.utilserv.soapPostwithoutAction(this.payShopingCartEnvelope(reqObject), AppSettings.OrderProcessingService);
  }
  payShopingCartEnvelope(reqObject: any) {
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    userGioLocation = reqObject.userGioLocation;
    let envelope =
      '<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope"> \n' +
      '<s:Header> \n' +
      '<a:Action s:mustUnderstand="1">http://tempuri.org/IOrderProcessingService/DoPayment</a:Action> \n' +
      '<a:MessageID>urn:uuid:1565225c-b03f-41b5-abc3-2a1c940080d6</a:MessageID> \n' +
      '<a:ReplyTo> \n' +
      '<a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address> \n' +
      '</a:ReplyTo> \n' +
      '</s:Header> \n' +
      '<s:Body> \n' +
      '<PaymentRequest xmlns="http://tempuri.org/"> \n' +
      '<Currency>' +
      reqObject.CurrencyFrom +
      '</Currency> \n' +
      '<EndUserLatitude>' +
      userGioLocation.latitude +
      '</EndUserLatitude> \n' +
      '<EndUserLongitude>' +
      userGioLocation.longitude +
      '</EndUserLongitude> \n' +
      '<EndUserIP>' +
      sessionStorage.EndUserIP +
      '</EndUserIP> \n' +
      `<EntryType>${AppSettings.Platform}</EntryType> \n` +
      '<FundingId>' +
      reqObject.fundingId +
      '</FundingId> \n' +
      '<Items xmlns:d4p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays" xmlns:i="http://www.w3.org/2001/XMLSchema-instance"> \n';

    reqObject.shopingCartList.forEach(element => {
      envelope += '<d4p1:int>' + element.itemId + '</d4p1:int> \n';
    });

    envelope +=
      '</Items> \n' +
      '<LanguageCode>' +
      sessionStorage.langCode +
      '</LanguageCode> \n' +
      '<Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance"> \n' +
      '<d4p1:T1>' +
      sessionStorage.T1 +
      '</d4p1:T1> \n' +
      '<d4p1:T2>' +
      sessionStorage.T2 +
      '</d4p1:T2> \n' +
      '</Session> \n' +
      '<TotalAmount>' +
      parseFloat(reqObject.totalAmount).toFixed(AppSettings.fractionDigit) +
      '</TotalAmount> \n' +
      '</PaymentRequest> \n' +
      '</s:Body> \n' +
      '</s:Envelope>';
    return envelope;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/dashboardservice/cart/cart-service.service.ts